// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiIndividual {
    static getAttributeTypeMap() {
        return PharmacyBiIndividual.attributeTypeMap;
    }
}
PharmacyBiIndividual.discriminator = undefined;
PharmacyBiIndividual.additionalProperties = false;
PharmacyBiIndividual.attributeTypeMap = [
    {
        "name": "deductibleExists",
        "baseName": "deductibleExists",
        "type": "string"
    },
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "string"
    },
    {
        "name": "deductibleTotal",
        "baseName": "deductibleTotal",
        "type": "string"
    },
    {
        "name": "oopMaximum",
        "baseName": "oopMaximum",
        "type": "string"
    },
    {
        "name": "oopMaximumExists",
        "baseName": "oopMaximumExists",
        "type": "string"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiIndividual.js.map